import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, FileText, PenLine } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Public read-only Terms of Engagement (linked from the proposal email).
export default function TermsPublic() {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    axios.get(`${BACKEND}/api/public/onboarding/${token}`)
      .then((r) => setDoc(r.data))
      .catch((e) => setErr(e.response?.data?.detail || "Could not load the terms."));
  }, [token]);

  if (err) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="card-flat p-8 max-w-md text-center" data-testid="terms-error">
          <FileText size={40} className="mx-auto text-[var(--ink-2)] mb-3" />
          <h1 className="text-xl font-serif-strong mb-2">Link unavailable</h1>
          <p className="text-sm text-[var(--ink-2)]">{err}</p>
        </div>
      </div>
    );
  }
  if (!doc) {
    return <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]"><Loader2 size={28} className="animate-spin text-[var(--navy)]" /></div>;
  }
  return (
    <div className="min-h-screen bg-[var(--bg)] py-8 px-4" data-testid="terms-page">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <img src="/brand/logo.png" alt="Finchley Business Services" className="h-10 w-auto" />
          <div>
            <div className="font-serif-strong text-lg">Finchley Business Services</div>
            <div className="text-xs text-[var(--ink-2)]">Terms of Engagement{doc.client_name ? ` — ${doc.client_name}` : ""}</div>
          </div>
        </div>
        {doc.letter_html && (
          <div className="card-flat p-6 mb-4">
            <div className="prose max-w-none text-sm leading-relaxed" data-testid="terms-content" dangerouslySetInnerHTML={{ __html: doc.letter_html }} />
          </div>
        )}
        {doc.msa_html && (
          <div className="card-flat p-6 mb-4">
            <div className="prose max-w-none text-sm leading-relaxed" data-testid="terms-msa-content" dangerouslySetInnerHTML={{ __html: doc.msa_html }} />
          </div>
        )}
        {doc.status !== "signed" && (
          <div className="text-center">
            <a href={`/sign/${token}`} data-testid="terms-go-sign" className="btn-primary inline-flex items-center gap-2 text-sm !py-2.5 !px-5">
              <PenLine size={14} /> Continue to registration &amp; signing
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
